var React = require('react');

function LoaderInline (props) {
    return React.createElement("div",props,React.createElement("svg",{"className":"circular","viewBox":"50 50 60 60"},React.createElement("circle",{"className":"path","cx":"75","cy":"75","r":"20","fill":"none","strokeWidth":"6","strokeMiterlimit":"10"})));
}

LoaderInline.defaultProps = {"className":"animate loader"};

module.exports = LoaderInline;

LoaderInline.default = LoaderInline;
